import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Login({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Login</title>
      <path
        d="M15.75 16.5C15.75 16.0858 15.4142 15.75 15 15.75C14.5858 15.75 14.25 16.0858 14.25 16.5H15.75ZM14.25 8.0625C14.25 8.47671 14.5858 8.8125 15 8.8125C15.4142 8.8125 15.75 8.47671 15.75 8.0625H14.25ZM20 12.75C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25V12.75ZM9 12L8.46967 11.4697C8.32902 11.6103 8.25 11.8011 8.25 12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303L9 12ZM10.9697 15.0303C11.2626 15.3232 11.7374 15.3232 12.0303 15.0303C12.3232 14.7374 12.3232 14.2626 12.0303 13.9697L10.9697 15.0303ZM12.0303 10.0303C12.3232 9.73744 12.3232 9.26256 12.0303 8.96967C11.7374 8.67678 11.2626 8.67678 10.9697 8.96967L12.0303 10.0303ZM6 3.75H13V2.25H6V3.75ZM13 20.25H6V21.75H13V20.25ZM4.75 19V5H3.25V19H4.75ZM14.25 16.5V19H15.75V16.5H14.25ZM20 11.25L9 11.25V12.75L20 12.75V11.25ZM8.46967 12.5303L10.9697 15.0303L12.0303 13.9697L9.53033 11.4697L8.46967 12.5303ZM9.53033 12.5303L12.0303 10.0303L10.9697 8.96967L8.46967 11.4697L9.53033 12.5303ZM6 20.25C5.30964 20.25 4.75 19.6904 4.75 19H3.25C3.25 20.5188 4.48122 21.75 6 21.75V20.25ZM13 21.75C14.5188 21.75 15.75 20.5188 15.75 19H14.25C14.25 19.6904 13.6904 20.25 13 20.25V21.75ZM13 3.75C13.6904 3.75 14.25 4.30964 14.25 5H15.75C15.75 3.48122 14.5188 2.25 13 2.25V3.75ZM6 2.25C4.48122 2.25 3.25 3.48122 3.25 5H4.75C4.75 4.30964 5.30964 3.75 6 3.75V2.25ZM14.25 5V8.0625H15.75V5H14.25Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
